import * as React from "react"
import * as RadixSelect from "@radix-ui/react-select"
import { cn } from "../../lib/utils"

export interface SelectProps extends RadixSelect.SelectProps {
  children: React.ReactNode
}

export const Select = React.forwardRef<HTMLButtonElement, SelectProps>(
  ({ children, ...props }, ref) => (
    <RadixSelect.Root {...props}>
      {children}
    </RadixSelect.Root>
  )
)
Select.displayName = "Select"

export const SelectTrigger = React.forwardRef<HTMLButtonElement, RadixSelect.SelectTriggerProps>(
  ({ className, children, ...props }, ref) => (
    <RadixSelect.Trigger ref={ref} className={cn("flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50", className)} {...props}>
      {children}
      <RadixSelect.Icon />
    </RadixSelect.Trigger>
  )
)
SelectTrigger.displayName = "SelectTrigger"

export const SelectValue = RadixSelect.Value
export const SelectContent = React.forwardRef<HTMLDivElement, RadixSelect.SelectContentProps>(
  ({ className, children, ...props }, ref) => (
    <RadixSelect.Portal>
      <RadixSelect.Content ref={ref} className={cn("z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md animate-in fade-in-80", className)} {...props}>
        <RadixSelect.Viewport>{children}</RadixSelect.Viewport>
      </RadixSelect.Content>
    </RadixSelect.Portal>
  )
)
SelectContent.displayName = "SelectContent"

export const SelectItem = React.forwardRef<HTMLDivElement, RadixSelect.SelectItemProps>(
  ({ className, children, ...props }, ref) => (
    <RadixSelect.Item ref={ref} className={cn("relative flex w-full cursor-pointer select-none items-center rounded-sm py-1.5 px-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className)} {...props}>
      <RadixSelect.ItemText>{children}</RadixSelect.ItemText>
      <RadixSelect.ItemIndicator className="absolute right-2 flex h-3.5 w-3.5 items-center justify-center">
        {/* You can add a checkmark icon here if desired */}
      </RadixSelect.ItemIndicator>
    </RadixSelect.Item>
  )
)
SelectItem.displayName = "SelectItem" 